<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    회의구분-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 회의구분
        </h5>
      </vs-col>
    </vs-row>
    <div class="mt-4">
      <vs-radio v-model="form.checkType" vs-value="최초" class="mr-4" onclick="return false">최초</vs-radio>
      <vs-radio v-model="form.checkType" vs-value="정기" class="mr-4" onclick="return false" :disabled="true">정기</vs-radio>
      <vs-radio v-model="form.checkType" vs-value="수시" class="mr-4" onclick="return false">수시</vs-radio>
    </div>

    <!--    협의체 정보-->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 협의체 정보</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">평가차수</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
        <ml-input
          v-else-if="board.readonly"
          v-model="form.inputB_1"
          class="w-full flex-1"
          readonly />
        <vs-select
          :disabled="board.readonly"
          v-else
          v-model="form.inputB_1"
          autocomplete
          class="w-full flex-1"
        >
          <vs-select-item v-for="index in 99" :key="index" :text="`${index}차`" :value="`${index}차`" />
        </vs-select>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">평가기간</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.inputB_2 }} ~ {{ form.inputB_3 }}
        </p>
        <div
          v-else
          class="w-full flex-1"
          style="display: flex; align-items: center"
        >
          <date-selector
            v-model="form.inputB_2"
            :readonly="board.readonly"
            @change="checkDate(form.inputB_2)"
          />
          &nbsp;~&nbsp;
          <date-selector
            v-model="form.inputB_3"
            :readonly="board.readonly"
            @change="checkDate(form.inputB_3)"
          />
        </div>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">회의일</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.inputB_4 }}
        </p>
        <div v-else class="flex-1 flex items-center">
          <date-selector
            class="w-full"
            v-model="form.inputB_4"
            :readonly="board.readonly"
          />
        </div>
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">회의장소</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_5 }}</p>
        <ml-input
          v-else
          v-model="form.inputB_5"
          class="w-full flex-1"
          :readonly="board.readonly"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">참석인원</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_6 }}</p>
        <ml-input
          v-else
          v-model="form.inputB_6"
          class="w-full flex-1"
          :readonly="board.readonly"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">참석업체</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_7 }}</p>
        <ml-input
          v-else
          v-model="form.inputB_7"
          class="w-full flex-1"
          :readonly="board.readonly"
        />
      </div>
    </div>

    <!--    주요 위험요인-->
    <table-risk-factor
      class="mt-5"
      :list="form.riskList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"/>

    <!--    협의내용-->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 협의내용</h5>
      </vs-col>
    </vs-row>
    <div class="print-container col-span-12 flex items-start mt-4">
      <div class="label-text mr-4 mt-2">협럭업체 건의사항<br/>(근로자 의견)</div>
      <p v-if="isPrint" class="print-textarea">{{ form.inputC_1 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputC_1"
        class="flex-1 w-full"
        rows="5"
      />
    </div>
    <div class="print-container col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">전달사항<br/>(경영자 의견)</div>
      <p v-if="isPrint" class="print-textarea">{{ form.inputC_2 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputC_2"
        class="flex-1 w-full"
        rows="5"
      />
    </div>

    <!--    이전 회차 FEED BACK-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 이전 회차 FEED BACK</h5>
      </vs-col>
    </vs-row>
    <div class="print-container col-span-12 flex items-start mt-4">
      <div class="label-text mr-4 mt-2">양호사항<br/>(전회 우수사례)</div>
      <p v-if="isPrint" class="print-textarea">{{ form.inputD_1 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputD_1"
        class="flex-1 w-full"
        rows="5"
      />
    </div>
    <div class="print-container col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">불량사항<br/>(전회 미결사항)</div>
      <p v-if="isPrint" class="print-textarea">{{ form.inputD_2 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputD_2"
        class="flex-1 w-full"
        rows="5"
      />
    </div>
    <div class="print-container col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">추가 위험요인</div>
      <p v-if="isPrint" class="print-textarea">{{ form.inputD_3 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputD_3"
        class="flex-1 w-full"
        rows="5"
      />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableInspectDivision from '@/components/TableInspectDivision'
import TableDuration from '../../../../components/TableDuration'
import TableRiskFactor from '@/components/TableRiskFactor'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    PhotoUploadGridModule,
    TableRiskFactor,
    TableDuration,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    checkDate(input) {
      if (Date.parse(this.form.inputB_2) > Date.parse(this.form.inputB_3)) {
        if (input === this.form.inputB_2) {
          this.form.inputB_3 = this.form.inputB_2;
        } else {
          this.form.inputB_2 = this.form.inputB_3;
        }
      }
    },
    updateList(list) {
      this.form.riskList = list;
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        checkType: '정기',

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",

        inputC_1: "",
        inputC_2: "",
        inputD_1: "",
        inputD_2: "",
        inputD_3: "",

        riskList: [],
        photoList: [],
        fileList: [],
      },
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
